import axios from 'axios';

export default {
    pre_insercion_ConPol(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_contactos.pre_insercion_ConPol",
				"p_args_in": JSON.stringify({
                    "p_usuario": p_usuario,
				  })
			})
	},

	consulta_poliza(p_email, p_ejecutivo, p_poliza){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_BaseDatos.fnc_consultaPoliza",
			"p_args_in": JSON.stringify({
				"p_ejecutivo": p_ejecutivo,
				"p_poliza": p_poliza,
			  })
		})
	},

	consulta_contratante(p_email, p_contratante){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_contactos.fnc_consultacontratante",
			"p_args_in": JSON.stringify({
				"p_contratante": p_contratante,
				})
		})
	},
	consulta_corredor(p_email, p_corredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_contactos.fnc_consultaCorredor",
			"p_args_in": JSON.stringify({
				"p_codcorredor": p_corredor,
				})
		})
	},
	Recuperar_ConPol(p_email, p_ejecutivo, p_poliza, p_contratante, p_corredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_contactos.Recuperar_ConPol",
			"p_args_in": JSON.stringify({
				"p_ejecutivo": p_ejecutivo,
				"p_poliza": p_poliza,
				"p_contratante": p_contratante,
				"p_corredor": p_corredor,
				})
		})
	},
	
	

	fnc_actualizar_ConPol(p_email, p_usuario, p_poliza, p_nomcontacto, 
						  p_mail_old, p_mail_new, p_rli, p_rpr){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_contactos.fnc_actualizar_ConPol",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_poliza": p_poliza,
				"p_nomcontacto": p_nomcontacto,
				"p_mail_old": p_mail_old,
				"p_mail_new": p_mail_new,
				"p_rli": p_rli,
				"p_rpr": p_rpr
				
				})
		});
	},

	fnc_eliminar_ConPol(p_email, p_usuario, p_poliza, p_nomcontacto, p_mail){
        return axios
        .post('spoc/modppentry', {
            "p_email": p_email,
            "p_metodo": "pkg_compp_contactos.fnc_eliminar_ConPol",
            "p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_poliza": p_poliza,
				"p_nomcontacto": p_nomcontacto,
				"p_mail": p_mail
                })
        })
    },

	fnc_actuliza_tpaviso(p_email, p_usuario, p_poliza, p_tpaviso){
        return axios
        .post('spoc/modppentry', {
            "p_email": p_email,
            "p_metodo": "pkg_compp_contactos.fnc_actuliza_tpaviso",
            "p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_poliza": p_poliza,
				"p_tpaviso": p_tpaviso
                })
        })
    },
	
}